import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const LoadingSpinner = ({ size = 40, thickness = 4, message = '' }) => {
  return (
    <Box 
      display="flex" 
      flexDirection="column"
      alignItems="center" 
      justifyContent="center" 
      p={3}
    >
      <CircularProgress size={size} thickness={thickness} />
      {message && (
        <Box mt={2}>
          {message}
        </Box>
      )}
    </Box>
  );
};

export default LoadingSpinner;
